import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import AiReport from '../components/screens/reporting/reports/AiReport';

export default function AskAi() {
  return (
    <Layout headerTitle="Ask AI">
      <PageContainer id="ask-ai">
        <AiReport />
      </PageContainer>
    </Layout>
  );
}
